import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Calendar from "react-calendar";
import MiniCalendar from "../calendarpage/MiniCalendar";
import {
  Avatar,
  Card,
  Divider,
  IconButton,
  Button,
  Typography,
  Modal,
  OutlinedInput,
  useMediaQuery,
} from "@mui/material";
import {
  AccessTime,
  AccessTimeFilled,
  Add,
  ArrowBack,
  LocationOn,
  Person,
  Phone,
} from "@mui/icons-material";
import { gql, useMutation, useQuery } from "@apollo/client";
import Times from "../calendarpage/Times";
import { format } from "date-fns";
import Error from "../Error";
import { getRatings, getUsers } from "../../graphql/querys";
import { Rating, LinearProgress, Box } from "@mui/material";
import { ADD_RATING, GET_RATING_DETAILS } from "../../graphql/mutations";
const NotFound = () => {
  return <Error />;
};

const CancelModal = ({
  showCancelModal,
  setShowCancelModal,
  bookingId,
  setBookingId,
  review,
  setReview,
  desc,
  addRating,
  data,
  refetch,
  setDesc,
  rating,
  setRating,
  errors,
  setErrors,
}) => {
  return (
    <Modal open={showCancelModal} onClose={() => setShowCancelModal(false)}>
      <Box
        className="flex column"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "10px",
          outline: "none",
          maxWidth: "400px",
          gap: "10px",
        }}
      >
        <Typography variant="h4">Post a Rating</Typography>
        <div>
          <Typography
            variant="h6"
            className="flex align"
            style={{ gap: "5px" }}
          >
            Your Booking Id
            <Typography className="font2" style={{ fontSize: "13px" }}>
              (Check your email)
            </Typography>
          </Typography>
          <OutlinedInput
            onChange={(e) => {
              setBookingId(e.target.value);
              setErrors(null);
            }}
            value={bookingId}
            fullWidth
            style={{ maxWidth: "500px", width: "300px" }}
          />
        </div>
        <div>
          <Typography variant="h6">Rating</Typography>
          <Rating
            onChange={(e) => {
              setRating(e.target.value);
              setErrors(null);
            }}
            value={rating}
          />
        </div>
        <div>
          <Typography variant="h6">Review</Typography>
          <OutlinedInput
            onChange={(e) => {
              setReview(e.target.value);
              setErrors(null);
            }}
            value={review}
            fullWidth
            style={{ maxWidth: "400px" }}
          />
        </div>
        <div>
          <Typography variant="h6">Description</Typography>
          <OutlinedInput
            onChange={(e) => {
              setDesc(e.target.value);
              setErrors(null);
            }}
            value={desc}
            multiline
            rows={4}
            fullWidth
            style={{ maxWidth: "400px" }}
          />
        </div>
        {errors && <Typography style={{ color: "red" }}>{errors}</Typography>}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={() => setShowCancelModal(false)}
            sx={{ mr: 2 }}
          >
            Nevermind
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (!rating || !desc || !review || !bookingId) {
                setErrors("Please provide a value for the inputs");
                return;
              }
              addRating({
                variables: {
                  eventId: parseInt(data.id),
                  rating: parseInt(rating),
                  desc,
                  review,
                  bookingId,
                },
              })
                .then((val) => {
                  setShowCancelModal(false);
                  refetch();
                })
                .catch((err) => {
                  console.log(err.message);
                  setErrors(err.message);
                });
            }}
            style={{ background: "#d9bca9" }}
          >
            POST
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
function EventsRatingPage(props) {
  const { id } = useParams();
  const { user } = useParams();
  const data = props.data.find((obj) => obj.link == id);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isSmallScreen2 = useMediaQuery("(max-width:900px)");
  const [showMore, setShowMore] = useState(
    data?.desc?.length > 300 ? true : null
  );
  const [selectedDate, setSelectedDate] = useState(null);
  const navigate = useNavigate();

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [addRating] = useMutation(ADD_RATING);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [review, setReview] = useState("");
  const [desc, setDesc] = useState("");
  const [rating, setRating] = useState("");
  const [errors, setErrors] = useState(false);

  const {
    loading,
    error,
    data: ratingsData,
    refetch,
  } = useQuery(getRatings, {
    variables: { eventId: parseInt(data?.id) },
  });
  function computeRatingPercentages(ratingArray) {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    const percentages = {};
    const total = ratingArray.length;

    // Count the frequency of each rating
    for (let i = 0; i < total; i++) {
      counts[ratingArray[i]] = (counts[ratingArray[i]] || 0) + 1;
    }
    // Calculate the percentage of each rating
    for (let rating in counts) {
      percentages[rating] = total ? (counts[rating] / total) * 100 : 0;
    }

    return percentages;
  }
  const [ratingsDisplay, setRatingsDisplay] = useState([]);
  const [ratings, setRatings] = useState({});
  const [getRatingsDetails] = useMutation(GET_RATING_DETAILS);
  useEffect(() => {
    if (!loading) {
      setRatings(
        computeRatingPercentages(
          ratingsData.getRatings.map((val) => val.rating)
        )
      );

      Promise.all(
        ratingsData.getRatings.map((val) =>
          getRatingsDetails({
            variables: { ratingId: parseInt(val.id) },
          })
        )
      ).then((values) => {
        console.log(values);
        const final = values.map((val) => val.data.getRatingDetails);
        setRatingsDisplay(final);
      });
    }
  }, [loading, ratingsData, getRatingsDetails]);
  if (loading) {
    return "loading";
  } else if (error) {
    return <Error />;
  }
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <IconButton
        onClick={() => {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.delete("date");
          const newUrl = `${
            window.location.pathname
          }?${searchParams.toString()}`;
          navigate(
            window.location.pathname.slice(
              0,
              window.location.pathname.length - 7
            )
          );
          setSelectedDate(null);
        }}
        style={{
          margin: "0px 0 0 27px",
          border: "1px solid lightgrey",
          height: "40px",
        }}
      >
        <ArrowBack />
      </IconButton>{" "}
      <CancelModal
        showCancelModal={showCancelModal}
        setShowCancelModal={setShowCancelModal}
        bookingId={bookingId}
        setBookingId={setBookingId}
        review={review}
        setReview={setReview}
        desc={desc}
        setDesc={setDesc}
        rating={rating}
        setRating={setRating}
        errors={errors}
        addRating={addRating}
        data={data}
        refetch={refetch}
        setErrors={setErrors}
      />
      <div
        className="flex column"
        style={{
          gap: "20px",
          maxWidth: "1000px",
          margin: "0 30px",
        }}
      >
        <Box mb={2}>
          <div
            className="width100 flex"
            style={{ justifyContent: "space-between" }}
          >
            <Typography variant="h6" gutterBottom className="align flex font">
              Ratings {"(" + ratingsData.getRatings.length + ")"}
            </Typography>
            <IconButton onClick={() => setShowCancelModal(true)}>
              <Add />
            </IconButton>
          </div>
          {[1, 2, 3, 4, 5].reverse().map((star) => (
            <Box key={star} display="flex" alignItems="center" mb={1}>
              <Typography variant="body2" style={{ width: 20 }}>
                {star}
              </Typography>
              <LinearProgress
                variant="determinate"
                value={ratings[star]}
                style={{ flex: 1, marginLeft: 10 }}
              />
            </Box>
          ))}
        </Box>{" "}
        <Box>
          <div
            className="width100 flex"
            style={{ justifyContent: "space-between" }}
          >
            {ratingsDisplay.map((star) => (
              <Box key={star.id} mb={1} display="flex" flexDirection="column">
                <div
                  className={
                    "flex align" +
                    (isSmallScreen || isSmallScreen2 ? " justify" : "")
                  }
                  style={{ gap: "10px" }}
                >
                  <Typography className="font" style={{ fontSize: "30px" }}>
                    {star.name}
                  </Typography>
                  <Rating readOnly value={star.rating} />
                </div>
                <div
                  className="flex column"
                  style={{ alignItems: "flex-start" }}
                >
                  <Typography className="font" style={{ fontSize: "20px" }}>
                    {star.review}
                  </Typography>
                  <Typography
                    className="font2"
                    style={{
                      fontSize: "18px",
                      maxWidth:
                        isSmallScreen || isSmallScreen2 ? "200px" : "400px",
                      wordBreak: "break-word",
                    }}
                  >
                    {star.desc}
                  </Typography>
                </div>
              </Box>
            ))}
          </div>
        </Box>
      </div>
    </div>
  );
}

export default EventsRatingPage;
